import { ISort } from '~/utils/sort/types';

interface ICell {
  id: string;
  label: string;
  useSort: boolean;
  width?: number;
}

export const headCells: ICell[] = [
  {
    id: 'name',
    label: 'Code',
    useSort: true,
    width: 150,
  },
  {
    id: 'description',
    label: 'Description',
    useSort: true,
  },
  {
    id: 'createdByUserFullName',
    label: 'Author',
    useSort: true,
    width: 200,
  },
  {
    id: 'actions',
    label: '',
    useSort: false,
    width: 100,
  },
];

export const initialSort: ISort = {
  orderBy: 'name',
  isDescending: false,
};

export default {};
